import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, computed, toJS, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";

export class EmailInboxListStore extends CoreStore {
  data: API_MailInbox[] = [];
  actionState: StoreState = "RAW";

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      actionState: observable,
      clear: action,
      list: computed,
      fetch: action.bound,
    });
  }

  clear() {
    this.data = [];
    this.actionState = "RAW";
  }

  url(listId?: number) {
    if (listId) {
      return API_URL.PROJECT_INBOXES.getMailInbox(projectsDataStore.projectId, listId);
    }
    return API_URL.PROJECT_INBOXES.getMailInboxes(projectsDataStore.projectId);
  }

  @handleStoreState()
  async fetch() {
    try {
      const response = await API.getData<API_MailInbox[]>(this.url());
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxListStore>("actionState")
  async deleteItem(listId: number) {
    try {
      await API.deleteData(this.url(listId));
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxListStore>("actionState")
  async editItem(listId: number, values: API_MailInbox) {
    try {
      await API.editData(this.url(listId), values);
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxListStore>("actionState")
  async createItem(values: API_MailInbox) {
    try {
      await API.newData(this.url(), values);
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  getItem(inboxId: number) {
    return this.data.find((item) => item.id === inboxId);
  }

  get list() {
    return toJS(this.data);
  }
}

export const emailInboxListStore = new EmailInboxListStore();
